// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loader_loaderContainer__EnBij","cutsomLoader":"Loader_cutsomLoader__YDsuK","spin":"Loader_spin__c+Bdd"};